<template>
    <div class="modal hide fade in" id="modalEnvio" data-keyboard="false" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title label-black">Nueva Incidencia</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="closeModal">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="form-group col-6">
                            <label class="label-black">Tipo de Incidencia</label>
                            <Incidencia
                             v-on:valorParaElPadre="cambioDeIncidencia" 
                            :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                            :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                            :idDelInput="'catalogoIncidencias'" 
                            :parametros="parametros_Incidencia" 
                            :valorDefinido="parametros_Incidencia.tipoIncidenciaId"
                            ></Incidencia>
                        </div>
                        <div class="form-group col-6" v-if="parametros_Incidencia.tipoIncidenciaId !=-1 && parametros_Incidencia.tipoIncidenciaId !=1 && parametros_Incidencia.tipoIncidenciaId!=6 && parametros_Incidencia.tipoIncidenciaId!=7 && parametros_Incidencia.tipoIncidenciaId!=10">
                            <label class="label-black">Categoria de Incidencia</label>
                            <SubIncidencias
                            v-on:valorParaElPadre="cambioDeSubIncidencia" 
                            :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                            :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                            :idDelInput="'catalogoSubIncidencias'" 
                            :parametros="parametros_SubIncidencia" 
                            :valorDefinido="parametros_SubIncidencia.tipoSubCategoriaIncidenciaId"
                            :key="parametros_SubIncidencia.tipoSubCategoriaIncidenciaId" 
                            :incidenciaId="parametros_Incidencia.tipoIncidenciaId"
                            ></SubIncidencias>
                        </div>
                    </div>
                    <!-- Pase Intermedio -->
                    <div v-if="parametros_Incidencia.tipoIncidenciaId==1 "> 
                        <div class="row">
                            <div class="form-group col-4" >
                                <label class="label-black">Fecha</label>
                                <input type="date" class="form-control" v-model="DetalleIncidencia.FechaInicio"/>
                            </div>
                            <div class="form-group col-4" >
                                <label class="label-black">Hora de Salida</label>
                                <input type="time" class="form-control" v-model="DetalleIncidencia.HoraSalida"/>
                            </div>
                            <div class="form-group col-4" >
                                <label class="label-black">Hora de Entrada</label>
                                <input type="time" class="form-control" v-model="DetalleIncidencia.HoraEntrada" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-12" >
                                <label class="label-black">Motivo</label>
                                <textarea type="text" class="form-control" v-model="DetalleIncidencia.Motivo" placeholder="Escriba algun motivo para el pase Intermedio"/>
                            </div>
                        </div>
                    </div>
                    <!-- Solicitud Dia Economico -->
                    <div v-if="parametros_Incidencia.tipoIncidenciaId==2 && parametros_SubIncidencia.tipoSubCategoriaIncidenciaId ==1"> 
                        <div v-if="areaGenera.AreaId==79">
                            <div class="row align-items-center" v-if="Estatus.DiaEconomico==false">
                                <div class="form-group col-12 text-center" >
                                    <label class="bg-danger text-white">Verificar antigüedad, el servidor público debe contar con un periódo de al menos 2 años continuos para generar esta incidencia.</label>
                                </div>
                            </div>
                            <div class="row align-items-center">
                                <div class="form-group col-6" >
                                    <label class="label-black">Dias Disponibles: {{DiasTramite}}</label>
                                </div>
                            </div>
                            <div class="row align-items-center">
                                <div class="form-group col-6" >
                                    <label class="label-black">Seleccione día</label>
                                    <input type="date" class="form-control" v-model="DetalleIncidencia.Dia" />
                                </div>
                                <div class="form-group col-6 ">
                                    <button class="btn btn-dark" @click='AgregarDia(parametros_Incidencia.tipoIncidenciaId,parametros_SubIncidencia.tipoSubCategoriaIncidenciaId)' v-if="DiasTramite!=0">Agregar Día</button>
                                </div>
                            </div>
                            <div class="row align-items-center">
                                <div class="form-group col-12" >
                                    <div id="diasEconomicos_table" class="table-reponsive">
                                        <table class="table table-striped table-light table-hover">
                                            <thead class="thead-custom">
                                                <tr>
                                                <th>No.</th>
                                                <th>Día</th>
                                                <th></th>
                                                </tr>
                                            </thead>
                                            <tbody class="text-dark">
                                                <tr v-if="ListadoDias.length <= 0">
                                                    <td colspan="12" class="text-center">No hay diás económicos</td>
                                                </tr>
                                                    <tr v-else v-for="dias in ListadoDias" >
                                                    <td>{{dias.No}}</td>
                                                    <td v-html="obtenFechaConFormato(dias.Dia)"></td>
                                                    <td>
                                                        <a v-on:click="EliminarDia(dias)" title="Eliminar Día">
                                                            <i class="fas fa-backspace"></i>
                                                        </a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="row align-items-center" >
                                <div class="form-group col-12" >
                                    <label class="label-black">Motivo</label>
                                    <textarea type="text" class="form-control" v-model="DetalleIncidencia.Motivo" placeholder="Escriba algun motivo para el pase Intermedio"/>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <div class="row align-items-center" v-if="Estatus.DiaEconomico==true">
                                <div class="form-group col-6" >
                                    <label class="label-black">Dias Disponibles: {{DiasTramite}}</label>
                                </div>
                            </div>
                            <div class="row align-items-center" v-if="Estatus.DiaEconomico==true">
                                <div class="form-group col-6" >
                                    <label class="label-black">Seleccione día</label>
                                    <input type="date" class="form-control" v-model="DetalleIncidencia.Dia" />
                                </div>
                                <div class="form-group col-6 ">
                                    <button class="btn btn-dark" @click='AgregarDia(parametros_Incidencia.tipoIncidenciaId,parametros_SubIncidencia.tipoSubCategoriaIncidenciaId)' v-if="DiasTramite!=0">Agregar Día</button>
                                </div>
                            </div>
                            <div class="row align-items-center" v-if="Estatus.DiaEconomico==true">
                                <div class="form-group col-12" >
                                    <div id="diasEconomicos_table" class="table-reponsive">
                                        <table class="table table-striped table-light table-hover">
                                            <thead class="thead-custom">
                                                <tr>
                                                <th>No.</th>
                                                <th>Día</th>
                                                <th></th>
                                                </tr>
                                            </thead>
                                            <tbody class="text-dark">
                                                <tr v-if="ListadoDias.length <= 0">
                                                    <td colspan="12" class="text-center">No hay diás económicos</td>
                                                </tr>
                                                    <tr v-else v-for="dias in ListadoDias" >
                                                    <td>{{dias.No}}</td>
                                                    <td v-html="obtenFechaConFormato(dias.Dia)"></td>
                                                    <td>
                                                        <a v-on:click="EliminarDia(dias)" title="Eliminar Día">
                                                            <i class="fas fa-backspace"></i>
                                                        </a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="row align-items-center" v-if="Estatus.DiaEconomico==true">
                                <div class="form-group col-12" >
                                    <label class="label-black">Motivo</label>
                                    <textarea type="text" class="form-control" v-model="DetalleIncidencia.Motivo" placeholder="Escriba algun motivo para el pase Intermedio"/>
                                </div>
                            </div>
                            <div class="row align-items-center" v-if="Estatus.DiaEconomico==false">
                                <div class="form-group col-12" >
                                    <label class="bg-danger text-white">El servidor público debe contar con una antigüedad de al menos 2 años continuos para generar esta incidencia, verifique con Recursos Humanos.</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Solicitud Vacaciones -->
                    <div v-if="parametros_Incidencia.tipoIncidenciaId==2 && parametros_SubIncidencia.tipoSubCategoriaIncidenciaId ==2">
                        <div v-if="areaGenera.AreaId==79">
                            <div class="row" v-if="Estatus.Vacaciones==false">
                                <div class="form-group col-12" >
                                    <label class="bg-danger text-white">Verificar antigüedad, el servidor público debe contar con una periódo de al menos 6 meses continuos para generar esta incidencia.</label>
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col-6" >
                                    <label class="label-black">Año</label>
                                    <input type="number" class="form-control" v-model="DetalleIncidencia.Anio" @change="cambiarAnio($event)" />
                                </div>
                                <div class="form-group col-6" >
                                    <label class="label-black">Período Vacacional</label>
                                    <select id="catalogodePeriodos" class="form-control" @change="cambiarPeriodo($event)">
                                        <option value= 0>Seleccione un Período</option>
                                        <option v-for="option in Periodos" v-bind:value="option.id" >{{ option.value }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="row" v-if="DetalleIncidencia.Periodo!=null && DetalleIncidencia.Anio!=null">
                                <div class="form-group col-3" >
                                    <label class="label-black">Dias por Periodo: 10</label>
                                </div>
                                <div class="form-group col-2" >
                                    <label class="label-black">Dias Disponibles:</label>
                                </div>
                                <div class="form-group col-2" >
                                    <label class="label-black">{{this.DiasVacacionesDisponibles}}</label>
                                </div>
                                <div class="form-group col-2" >
                                    <label class="label-black">Dias a Solicitar:</label>
                                </div>
                                <div class="form-group col-2" >
                                    <label class="label-black">{{this.DiasASolicitar}}</label>
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col-6" >
                                    <label class="label-black">Fecha de Inicio</label>
                                    <input type="date" class="form-control" v-model="DetalleIncidencia.FechaInicio"/>
                                </div>
                                <div class="form-group col-6" >
                                    <label class="label-black">Fecha de Termino</label>
                                    <input type="date" class="form-control" v-model="DetalleIncidencia.FechaTermino" @change="ObtenerDiasASolicitar(DetalleIncidencia.FechaInicio, DetalleIncidencia.FechaTermino)" />
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <div class="row" v-if="Estatus.Vacaciones==true">
                                <div class="form-group col-6" >
                                    <label class="label-black">Año</label>
                                    <input type="number" class="form-control" v-model="DetalleIncidencia.Anio" @change="cambiarAnio($event)" />
                                </div>
                                <div class="form-group col-6" >
                                    <label class="label-black">Período Vacacional</label>
                                    <select id="catalogodePeriodos" class="form-control" @change="cambiarPeriodo($event)">
                                        <option value= 0>Seleccione un Período</option>
                                        <option v-for="option in Periodos" v-bind:value="option.id" >{{ option.value }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="row" v-if="DetalleIncidencia.Periodo!=null && DetalleIncidencia.Anio!=null && Estatus.Vacaciones==true">
                                <div class="form-group col-3" >
                                    <label class="label-black">Dias por Periodo: 10</label>
                                </div>
                                <div class="form-group col-2" >
                                    <label class="label-black">Dias Disponibles:</label>
                                </div>
                                <div class="form-group col-2" >
                                    <label class="label-black">{{this.DiasVacacionesDisponibles}}</label>
                                </div>
                                <div class="form-group col-2" >
                                    <label class="label-black">Dias a Solicitar:</label>
                                </div>
                                <div class="form-group col-2" >
                                    <label class="label-black">{{this.DiasASolicitar}}</label>
                                </div>
                            </div>
                            <div class="row" v-if="Estatus.Vacaciones==true">
                                <div class="form-group col-6" >
                                    <label class="label-black">Fecha de Inicio</label>
                                    <input type="date" class="form-control" v-model="DetalleIncidencia.FechaInicio"/>
                                </div>
                                <div class="form-group col-6" >
                                    <label class="label-black">Fecha de Termino</label>
                                    <input type="date" class="form-control" v-model="DetalleIncidencia.FechaTermino" @change="ObtenerDiasASolicitar(DetalleIncidencia.FechaInicio, DetalleIncidencia.FechaTermino)" />
                                </div>
                            </div>
                            <div class="row" v-if="Estatus.Vacaciones==false">
                                <div class="form-group col-12" >
                                    <label class="bg-danger text-white">El servidor público debe contar con una antigüedad al menos 6 meses continuos para generar esta incidencia, verifique con Recursos Humanos</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Solicitud sustitucion de dia -->
                    <div v-if="parametros_Incidencia.tipoIncidenciaId==2 && parametros_SubIncidencia.tipoSubCategoriaIncidenciaId ==3">
                        <div class="row">
                            <div class="form-group col-6" >
                                    <label class="label-black">Año</label>
                                    <input type="number" class="form-control" v-model="DetalleIncidencia.Anio" @change="cambiarAnio($event)" />
                                </div>
                            <div class="form-group col-6" >
                                    <label class="label-black">Período Vacacional</label>
                                    <select id="catalogodePeriodos" class="form-control" @change="cambiarPeriodo($event)">
                                        <option value= 0>Seleccione un Período</option>
                                        <option v-for="option in Periodos" v-bind:value="option.id" >{{ option.value }}</option>
                                    </select>
                                </div>
                        </div>
                        <div class="row" v-if="DetalleIncidencia.Periodo!=null && DetalleIncidencia.Anio!=null">
                                <div class="form-group col-3" >
                                    <label class="label-black">Dias por Periodo: 10</label>
                                </div>
                                <div class="form-group col-2" >
                                    <label class="label-black">Dias Disponibles:</label>
                                </div>
                                <div class="form-group col-2" >
                                    <label class="label-black">{{this.DiasVacacionesDisponibles}}</label>
                                </div>
                                <div class="form-group col-2" >
                                    <label class="label-black">Dias a Solicitar:</label>
                                </div>
                                <div class="form-group col-2" >
                                    <label class="label-black">{{this.DiasASolicitar}}</label>
                                </div>
                        </div>
                        <div class="row" v-if="DetalleIncidencia.Periodo!=null && DetalleIncidencia.Anio!=null">
                            <div class="form-group col-6" >
                                <label class="label-black">Día que Solicita</label>
                                <input type="date" class="form-control" v-model="DetalleIncidencia.DiaSustitucion"/>
                            </div>
                            <div class="form-group col-6" >
                                <label class="label-black">Por el Día</label>
                                <input type="date" class="form-control" v-model="DetalleIncidencia.DiaOriginal" @change="VerficarExisteEnVacaciones(DetalleIncidencia.DiaOriginal)"/>
                            </div>
                        </div>
                        
                        <div class="row" v-if="DetalleIncidencia.Periodo!=null && DetalleIncidencia.Anio!=null">
                            <div class="form-group col-12" >
                                <label class="label-black">Motivo</label>
                                <textarea type="text" class="form-control" v-model="DetalleIncidencia.Motivo" placeholder="Escriba algun motivo para la sustitución de día"/>
                            </div>
                        </div>
                    </div>
                    <!-- Permiso Estudiante -->
                    <div v-if="parametros_Incidencia.tipoIncidenciaId==3 && parametros_SubIncidencia.tipoSubCategoriaIncidenciaId ==4">
                        <div class="row">
                            <div class="form-group col-12" >
                                <h6>Período</h6>
                            </div>
                        </div>
                         <div class="row">
                            <div class="form-group col-6" >
                                <label class="label-black">Fecha de Inicio</label>
                                <input type="date" class="form-control" v-model="DetalleIncidencia.FechaInicio"/>
                            </div>
                            <div class="form-group col-6" >
                                <label class="label-black">Fecha de Termino</label>
                                <input type="date" class="form-control" v-model="DetalleIncidencia.FechaTermino" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-12" >
                                <h6>Horario</h6>
                            </div>
                        </div>
                         <div class="row">
                            <div class="form-group col-6" >
                                <label class="label-black">De</label>
                                <input type="time" class="form-control" v-model="DetalleIncidencia.HoraInicio"/>
                            </div>
                            <div class="form-group col-6" >
                                <label class="label-black">Hasta</label>
                                <input type="time" class="form-control" v-model="DetalleIncidencia.HoraFinal" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-3">
                                <label class="label-black" >Anexa Constancia</label>
                            </div>
                            <div class="form-group col-6">
                                <input type="checkbox" v-model="DetalleIncidencia.Constancia">
                            </div>
                        </div>
                    </div>
                    <!-- Hora de Lactancia -->
                    <div v-if="parametros_Incidencia.tipoIncidenciaId==3 && parametros_SubIncidencia.tipoSubCategoriaIncidenciaId ==5">
                        <div class="row">
                            <div class="form-group col-12" >
                                <h6>Período</h6>
                            </div>
                        </div>
                         <div class="row">
                            <div class="form-group col-6" >
                                <label class="label-black">Fecha de Inicio</label>
                                <input type="date" class="form-control" v-model="DetalleIncidencia.FechaInicio"/>
                            </div>
                            <div class="form-group col-6" >
                                <label class="label-black">Fecha de Termino</label>
                                <input type="date" class="form-control" v-model="DetalleIncidencia.FechaTermino" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-12" >
                                <h6>Horario</h6>
                            </div>
                        </div>
                         <div class="row">
                            <div class="form-group col-6" >
                                <label class="label-black">De</label>
                                <input type="time" class="form-control" v-model="DetalleIncidencia.HoraInicio"/>
                            </div>
                            <div class="form-group col-6" >
                                <label class="label-black">Hasta</label>
                                <input type="time" class="form-control" v-model="DetalleIncidencia.HoraFinal" />
                            </div>
                        </div>
                    </div>
                    <!-- Otro -->
                    <div v-if="parametros_Incidencia.tipoIncidenciaId==3 && parametros_SubIncidencia.tipoSubCategoriaIncidenciaId ==6">
                        <div class="row">
                            <div class="form-group col-12" >
                                <label class="label-black">Motivo</label>
                                <textarea type="text" class="form-control" v-model="DetalleIncidencia.Motivo" placeholder="Escriba algun motivo para el pase Intermedio"/>
                            </div>
                        </div>
                    </div>
                    <!-- Fallecimiento Traslado Enfermedad -->
                    <div v-if="parametros_Incidencia.tipoIncidenciaId==4 && (parametros_SubIncidencia.tipoSubCategoriaIncidenciaId ==7 || parametros_SubIncidencia.tipoSubCategoriaIncidenciaId ==8 || parametros_SubIncidencia.tipoSubCategoriaIncidenciaId ==10 )">
                        <div class="row">
                            <div class="form-group col-12" >
                                <h6>Licencia con goce de sueldo Art.47 del Reglamento interior de Trabajo</h6>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-8" >
                                <label class="label-black">Nombre</label>
                                <input type="text" class="form-control" v-model="DetalleIncidencia.Nombre" placeholder="Escriba el Nombre del Pariente"/>   
                            </div>
                            <div class="form-group col-4" >
                                <label class="label-black">Tipo Parentesco</label>
                                <C008TiposParentesco
                                :idDelInput="'catalogoTipoParentesco'"
                                :key="parametros_tipoParentesco.tipoParentescoId"
                                :valorDefinido="parametros_tipoParentesco.tipoParentescoId"
                                :prefijo="enumeraciones.etiquetasDeHTML.Select"
                                :tipo="enumeraciones.tiposDeSelect.Seleccione"
                                v-on:valorParaElPadre="cambiarParentesco"
                                ></C008TiposParentesco>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-6" >
                                <label class="label-black">Fecha de Inicio</label>
                                <input type="date" class="form-control" v-model="DetalleIncidencia.FechaInicio"/>
                            </div>
                            <div class="form-group col-6" >
                                <label class="label-black">Fecha de Termino</label>
                                <input type="date" class="form-control" v-model="DetalleIncidencia.FechaTermino" />
                            </div>
                        </div>
                    </div>
                    <!-- Matrimonio  Diligencia-->
                    <div v-if="parametros_Incidencia.tipoIncidenciaId==4 && (parametros_SubIncidencia.tipoSubCategoriaIncidenciaId ==9 || parametros_SubIncidencia.tipoSubCategoriaIncidenciaId ==11)">
                        <div class="row">
                            <div class="form-group col-12" >
                                <h6>Licencia con goce de sueldo Art.47 del Reglamento interior de Trabajo</h6>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-6" >
                                <label class="label-black">Fecha de Inicio</label>
                                <input type="date" class="form-control" v-model="DetalleIncidencia.FechaInicio"/>
                            </div>
                            <div class="form-group col-6" >
                                <label class="label-black">Fecha de Termino</label>
                                <input type="date" class="form-control" v-model="DetalleIncidencia.FechaTermino" />
                            </div>
                        </div>
                    </div>
                    <!-- Maternidad-->
                    <div v-if="parametros_Incidencia.tipoIncidenciaId==5 && parametros_SubIncidencia.tipoSubCategoriaIncidenciaId ==12">
                        <div class="row">
                            <div class="form-group col-6" >
                                <label class="label-black">Fecha de Inicio</label>
                                <input type="date" class="form-control" v-model="DetalleIncidencia.FechaInicio" @change='Maternidad()' />
                            </div>
                            <div class="form-group col-6" >
                                <label class="label-black">Fecha de Termino</label>
                                <input type="date" class="form-control" v-model="DetalleIncidencia.FechaTermino" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-12" >
                                <label class="label-black">Otra Solicitud</label>
                                <textarea type="text" class="form-control" v-model="DetalleIncidencia.OtraSolicitud" placeholder="Describa el detalle de la Solicitud"/>
                            </div>
                        </div>
                    </div>
                    <!-- Paternidad-->
                    <div v-if="parametros_Incidencia.tipoIncidenciaId==5 && parametros_SubIncidencia.tipoSubCategoriaIncidenciaId ==13">
                      <div class="row">
                            <div class="form-group col-6" >
                                <label class="label-black">Fecha de Inicio</label>
                                <input type="date" class="form-control" v-model="DetalleIncidencia.FechaInicio"/>
                            </div>
                            <div class="form-group col-6" >
                                <label class="label-black">Fecha de Termino</label>
                                <input type="date" class="form-control" v-model="DetalleIncidencia.FechaTermino" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-12" >
                                <label class="label-black">Otra Solicitud</label>
                                <textarea type="text" class="form-control" v-model="DetalleIncidencia.OtraSolicitud" placeholder="Describa el detalle de la Solicitud"/>
                            </div>
                        </div>
                    </div>
                    <!-- Ampliacion Maternidad-->
                    <div v-if="parametros_Incidencia.tipoIncidenciaId==6 ">
                        <div class="row">
                            <div class="form-group col-6" >
                                <label class="label-black">Fecha de Inicio</label>
                                <input type="date" class="form-control" v-model="DetalleIncidencia.FechaInicio"/>
                            </div>
                            <div class="form-group col-6" >
                                <label class="label-black">Fecha de Termino</label>
                                <input type="date" class="form-control" v-model="DetalleIncidencia.FechaTermino" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-12" >
                                <label class="label-black">Motivo</label>
                            </div>
                            <div class="form-group col-12" >
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" name="motivo1" id="motivo1_id" v-model="checkMotivo.mot1">
                                    <label class="form-check-label" for="motivo1_id" id="label1_id">I. En caso de parto prematuro</label>
                                </div>
                            </div>
                            <div class="form-group col-12" >
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" name="motivo2" id="motivo2_id" v-model="checkMotivo.mot2" >
                                    <label class="form-check-label" for="motivo2_id" id="label2_id">II. En caso de que el menor presente problemas de salud que pongan en peligro su vida, ameriten intervención quirúrgica o cuidados intensivos</label>
                                </div>
                            </div>
                            <div class="form-group col-12" >
                                 <div class="form-check">
                                    <input class="form-check-input" type="checkbox" name="motivo1" id="motivo3_id" v-model="checkMotivo.mot3" >
                                    <label class="form-check-label" for="motivo3_id" id="label3_id">III. Si el menor presenta alguna discapacidad al nacer</label>
                                </div>
                            </div>
                            <div class="form-group col-12" >
                                 <div class="form-check">
                                    <input class="form-check-input" type="checkbox" name="motivo4" id="motivo4_id" v-model="checkMotivo.mot4" >
                                    <label class="form-check-label" for="motivo4_id" id="label4_id">IV. En caso de parto múltiple</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Ampliacion Paternidad-->
                    <div v-if="parametros_Incidencia.tipoIncidenciaId==7 ">
                        <div class="row">
                            <div class="form-group col-6" >
                                <label class="label-black">Fecha de Inicio</label>
                                <input type="date" class="form-control" v-model="DetalleIncidencia.FechaInicio"/>
                            </div>
                            <div class="form-group col-6" >
                                <label class="label-black">Fecha de Termino</label>
                                <input type="date" class="form-control" v-model="DetalleIncidencia.FechaTermino" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-12" >
                                <label class="label-black">Motivo</label>
                            </div>
                            <div class="form-group col-12" >
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" name="motivo1" id="motivo1_id" v-model="checkMotivo.mot1">
                                    <label class="form-check-label" for="motivo1_id" id="label1_id">I. En caso de enfermedad grave o discapacidad del hijo o hija recién nacidos o adoptados</label>
                                </div>
                            </div>
                            <div class="form-group col-12" >
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" name="motivo2" id="motivo2_id" v-model="checkMotivo.mot2">
                                    <label class="form-check-label" for="motivo2_id" id="label2_id">II. Por complicaciones graves de salud de la madre con motivo del nacimiento del hijo o hija</label>
                                </div>
                            </div>
                            <div class="form-group col-12" >
                                 <div class="form-check">
                                    <input class="form-check-input" type="checkbox" name="motivo1" id="motivo3_id"  v-model="checkMotivo.mot3">
                                    <label class="form-check-label" for="motivo3_id" id="label3_id">III. En caso de parto múltiple</label>
                                </div>
                            </div>
                            <div class="form-group col-12" >
                                 <div class="form-check">
                                    <input class="form-check-input" type="checkbox" name="motivo4" id="motivo4_id" v-model="checkMotivo.mot4" >
                                    <label class="form-check-label" for="motivo4_id" id="label4_id">IV. En caso del fallecimiento de la madre</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Ausencia Justificada/Injustificada-->
                    <div v-if="parametros_Incidencia.tipoIncidenciaId==8 && (parametros_SubIncidencia.tipoSubCategoriaIncidenciaId ==14 || parametros_SubIncidencia.tipoSubCategoriaIncidenciaId ==15) ">
                        <div class="row align-items-center">
                            <div class="form-group col-6" >
                                <label class="label-black">Seleccione día</label>
                                <input type="date" class="form-control" v-model="DetalleIncidencia.FechaInicio" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-12" >
                                <label class="label-black">Motivo</label>
                                <textarea type="text" class="form-control" v-model="DetalleIncidencia.Motivo" placeholder="Escriba algun motivo para el pase Intermedio"/>
                            </div>
                        </div>
                    </div>
                    <!-- Justificacion Entrada/Salida-->
                    <div v-if="parametros_Incidencia.tipoIncidenciaId==9 && (parametros_SubIncidencia.tipoSubCategoriaIncidenciaId ==16 || parametros_SubIncidencia.tipoSubCategoriaIncidenciaId ==17) ">
                        <div class="row">
                            <div class="form-group col-6" >
                                <label class="label-black">Fecha</label>
                                <input type="date" class="form-control" v-model="DetalleIncidencia.FechaInicio"/>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-12" >
                                <label class="label-black">Motivo</label>
                                <textarea type="text" class="form-control" v-model="DetalleIncidencia.Motivo" placeholder="Escriba algun motivo para el pase Intermedio"/>
                            </div>
                        </div>
                    </div>
                    <!-- Licencia sin Goce de Sueldo-->
                    <div v-if="parametros_Incidencia.tipoIncidenciaId==10">
                        <div class="row" v-if="Estatus.Base==true">
                            <div class="form-group col-6" >
                                <label class="label-black">Fecha de Inicio</label>
                                <input type="date" class="form-control" v-model="DetalleIncidencia.FechaInicio"/>
                            </div>
                            <div class="form-group col-6" >
                                <label class="label-black">Fecha de Termino</label>
                                <input type="date" class="form-control" v-model="DetalleIncidencia.FechaTermino" />
                            </div>
                        </div>
                        <div class="row" v-else>
                            <div class="form-group col-12" >
                                <label class="bg-danger text-white">Por tipo de contrato no es posible generar esta Incidencia, Verifique con Recursos Humanos</label>
                            </div>
                        </div>
                        <div class="row" v-if="Estatus.Base==true">
                            <div class="form-group col-12" >
                                <label class="label-black">Motivo</label>
                                <textarea type="text" class="form-control" v-model="DetalleIncidencia.Motivo" placeholder="Escriba algun motivo para el pase Intermedio"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary btn-sm" id="botonCancelar" >Cancelar</button>
                    <button type="button" class="btn btn-custom btn-sm" id="botonAceptar" >Aceptar</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import enumeraciones from '@/../static/js/enumeraciones'
import api from '@/../static/js/api'
import comun from '@/../static/js/comun'
import axios from 'axios'
import catalogos from '@/../static/js/catalogos'

export default {
    components:{
        Incidencia: catalogos.SIAP.C033TipoIncidencias,
        SubIncidencias: catalogos.SIAP.C034TipoSubIncidencias,
        C008TiposParentesco: catalogos.SIAP.C008TipoParentesco
    },
    props:{
        PersonaModal: Object,
        ListadoInhabiles: Array,
        Estatus: Object,
        areaGenera: Object
    },
    data(){
        return{
            enumeraciones,
            parametros_Incidencia :{
                tipoIncidenciaId: -1
            },
            parametros_SubIncidencia:{
                tipoSubCategoriaIncidenciaId: -1
            },
            parametros_tipoParentesco:{
                tipoParentescoId: -1
            },
            DetalleIncidencia: {
                Dia: null,
                HoraEntrada: null,
                HoraSalida: null,
                HoraInicio: null,
                HoraFinal: null,
                Motivo: null,
                Nombre: null,
                Parentesco: {
                    TipoParentescoId: null,},
                FechaInicio: null,
                FechaTermino: null,
                Constancia: null,
                Periodo: null,
                Anio: null,
                DiasVacaciones: null,
                DiaOriginal: null,
                DiaSustitucion: null,
                OtraSolicitud: null,
            },
            ListadoIncidencias : [],
            ListadoDias:[],
            DiasTramite: 0,
            ContDias: 0,
            Periodos:[
                {id: 1, value: "Primer Período"},
                {id: 2, value: "Segundo Período"}
            ],
            ContadorVacaciones: 0,
            DiasVacacionesDisponibles: 10,
            DiasASolicitar:0,
            checkMotivo:{
                mot1: false,
                mot2: false,
                mot3: false,
                mot4: false
            }
        }
    },
    methods: {
        obtenFechaConFormato: function(fechaDia) {
            return moment(fechaDia).format("DD-MM-YYYY");
        },
        Mostrar: function () {
        $('#modalEnvio').modal('show');
        $('#botonCancelar').unbind('click').click(this.CerrarModal);
        $('#closeModal').unbind('click').click(this.CerrarModal);
        $('#botonAceptar').unbind('click').click(this.CrearIncidencia);
        },
        ModalClose: function(b1, b2, nom){
            $('#modalEnvio').modal('hide');
            //$('#modalSolicitud').modal('dispose');
            this.$emit('dialogo', {'Cerrar':b1, 'Actualizar':b2, 'Nomina':nom});
        },
        cambioDeIncidencia(datos){
            this.parametros_Incidencia.tipoIncidenciaId = parseInt(datos.target.value);
            this.parametros_SubIncidencia.tipoSubCategoriaIncidenciaId = -1;
            this.LimpiaCampos();
        },
        cambioDeSubIncidencia(datos){
            this.parametros_SubIncidencia.tipoSubCategoriaIncidenciaId = parseInt(datos.target.value);
            this.LimpiaCampos();
            if(this.parametros_SubIncidencia.tipoSubCategoriaIncidenciaId==2 || this.parametros_SubIncidencia.tipoSubCategoriaIncidenciaId==3)
            {
                this.DetalleIncidencia.Anio = moment().format('YYYY');
            }
        },
        cambiarParentesco(datos){
            this.parametros_tipoParentesco.tipoParentescoId = parseInt(datos.target.value);
            this.DetalleIncidencia.Parentesco.TipoParentescoId = parseInt(datos.target.value);
        },
        cambiarAnio(){
            this.DetalleIncidencia.Periodo= null;
            $("#catalogodePeriodos option[value='0']").prop("selected",true);
        },
        cambiarPeriodo(datos){
            if(datos.target.value!= 0)
            {
                this.DetalleIncidencia.Periodo = parseInt(datos.target.value);
                this.ContadorVacaciones = this.ObtenerDiasVacacionesEnIncidencias(this.PersonaModal.Incidencias, this.DetalleIncidencia.Periodo, this.DetalleIncidencia.Anio);
                this.DiasVacacionesDisponibles = (10 - parseInt(this.ContadorVacaciones));
            }
        },
        LimpiaCampos(){
                this.DetalleIncidencia.Dia= null;
                this.DetalleIncidencia.HoraEntrada= null;
                this.DetalleIncidencia.HoraSalida= null;
                this.DetalleIncidencia.HorarioInicio= null;
                this.DetalleIncidencia.HorarioFinal= null;
                this.DetalleIncidencia.Motivo= null;
                this.DetalleIncidencia.Nombre= null;
                this.DetalleIncidencia.Parentesco.TipoParentescoId= null;
                this.DetalleIncidencia.FechaInicio= null;
                this.DetalleIncidencia.FechaTermino= null;
                this.DetalleIncidencia.Constancia= null;
                this.DetalleIncidencia.Periodo= null;
                this.DetalleIncidencia.Anio= null;
                this.DetalleIncidencia.DiaOriginal= null;
                this.DetalleIncidencia.DiasVacaciones=null;
                this.DetalleIncidencia.DiaSustitucion= null;
                this.DetalleIncidencia.OtraSolicitud= null;
                this.DetalleIncidencia.checkMotivo= false;
                // this.DetalleIncidencia.checkMotivo.mot2 = false;
                // this.DetalleIncidencia.checkMotivo.mot3 = false;
                // this.DetalleIncidencia.checkMotivo.mot4 = false;
        },
        ValidaCamposPorTipoIncidencia(){
            if(this.parametros_Incidencia.tipoIncidenciaId==-1)
            {
                comun.mensajeDeAlerta("Seleccione un tipo de Incidencia", null, null);
                return false;
            }
            if(this.parametros_Incidencia.tipoIncidenciaId==1) //Pase intermedio
            {
                this.ListadoIncidencias.push (this.DetalleIncidencia);
                    if(this.DetalleIncidencia.FechaInicio==null)
                    {
                        comun.mensajeDeAlerta("Defina Fecha de Incidencia", null, null);
                        return false;
                    };
                    if(this.DetalleIncidencia.HoraSalida==null)
                    {
                        comun.mensajeDeAlerta("Defina Hora de Salida", null, null);
                        return false;
                    };
                    if(this.DetalleIncidencia.HoraEntrada==null)
                    {
                        comun.mensajeDeAlerta("Defina Hora de Entrada", null, null);
                        return false;
                    };
                    if(this.DetalleIncidencia.HoraSalida > this.DetalleIncidencia.HoraEntrada)
                    {
                        comun.mensajeDeAlerta("Hora de Entrada no puede ser mayor a Hora de Salida", null, null);
                        return false;
                    };
                    if(this.DetalleIncidencia.Motivo==null)
                    {
                        comun.mensajeDeAlerta("Defina un Motivo para la incidencia", null, null);
                        return false;
                    }
            };
            if(this.parametros_Incidencia.tipoIncidenciaId==2) //Solicitud de dia
            {
                if(this.parametros_SubIncidencia.tipoSubCategoriaIncidenciaId == -1)
                {
                    comun.mensajeDeAlerta("Seleccione una categoria para la incidencia", null, null);
                    return false;
                };
                if(this.parametros_SubIncidencia.tipoSubCategoriaIncidenciaId == 1) //Dia Economico
                {   
                        if(this.Estatus.DiaEconomico==false){
                        comun.mensajeDeAlerta("No es posible Generar esta Incidencia", null, null);
                        return false;
                        }
                        var motivoDia = this.DetalleIncidencia.Motivo;
                        var ListadoDiasAAgregar =[];
                        if(this.ListadoDias.length>0)
                        {
                            $.each(this.ListadoDias, function(index, diasSeleccionados)
                            {   
                                var Temporal = {Dia:null, Motivo: ""};
                                Temporal.Dia = diasSeleccionados.Dia;
                                Temporal.Motivo= motivoDia;
                                ListadoDiasAAgregar.push(Temporal);
                            });
                            this.ListadoIncidencias = ListadoDiasAAgregar;
                        }
                        else
                        {
                            comun.mensajeDeAlerta("No hay días agregados para tramitar esta incidencia", null, null);
                            return false;
                        }             
                };
                if(this.parametros_SubIncidencia.tipoSubCategoriaIncidenciaId == 2) //Vacaciones
                {
                    if(this.Estatus.Vacaciones==false){
                    comun.mensajeDeAlerta("No es posible Generar esta Incidencia", null, null);
                    return false;
                    }
                    if(this.DetalleIncidencia.FechaInicio==null)
                    {
                        comun.mensajeDeAlerta("Defina fecha de inicio", null, null);
                        return false;
                    };
                    if(this.DetalleIncidencia.FechaTermino==null)
                    {
                        comun.mensajeDeAlerta("Defina fecha de Termino", null, null);
                        return false;
                    };
                    if(this.DetalleIncidencia.FechaInicio > this.DetalleIncidencia.FechaTermino)
                    {
                        comun.mensajeDeAlerta("El limite inferior del rango no puede mayor al limite Superior", null, null);
                        return false;
                    };
                    if(this.DetalleIncidencia.Anio == null)
                    {
                        comun.mensajeDeAlerta("Determine el Año del periodo Vacacional", null, null);
                        return false;
                    }
                    if(this.DetalleIncidencia.Periodo == null)
                    {
                        comun.mensajeDeAlerta("Determine el periodo Vacacional", null, null);
                        return false;
                    }
                    this.DetalleIncidencia.DiasVacaciones = this.ObtenerDiasHabiles(this.DetalleIncidencia.FechaInicio, this.DetalleIncidencia.FechaTermino);
                    if(parseInt(this.DiasVacacionesDisponibles)==0)
                    {
                       comun.mensajeDeAlerta("No es posible crear esta Incidencia, se ha superado la cantidad de dias correspodiente al Período Vacacional", null, null);
                        return false; 
                    }
                    if(parseInt(this.DiasVacacionesDisponibles) >= parseInt(this.DetalleIncidencia.DiasVacaciones))
                    {
                        //if(this.DetectarEmpalmeVacaciones(this.PersonaModal.Incidencias, this.DetalleIncidencia)== false).Periodo, this.DetalleIncidencia.Anio)==false)
                        var valor = this.VerificarDiasEnOtrasIncidencias(this.PersonaModal.Incidencias, this.DetalleIncidencia);
                        if(valor.Estatus== false)
                        {
                            this.ListadoIncidencias.push(this.DetalleIncidencia);
                        }
                        else
                        {
                            comun.mensajeDeAlerta("No se Puede Crear Incidencia, algun(os) dia(as) coincide con otra incidencia registrada No " + valor.Incidencia, null, null);
                            return false;
                        }
                        
                    }
                    else{
                        comun.mensajeDeAlerta("No es posible crear esta Incidencia, se ha superado la cantidad de dias correspodiente al Período Vacacional", null, null);
                        return false;
                    }
                    
                };
                if(this.parametros_SubIncidencia.tipoSubCategoriaIncidenciaId == 3) // Sustitucion de dia
                {
                    if(this.DetalleIncidencia.DiaOriginal==null)
                    {
                        comun.mensajeDeAlerta("Defina el día que se requiere cambiar", null, null);
                        return false;
                    }
                    if(this.DetalleIncidencia.DiaSustitucion==null)
                    {
                        comun.mensajeDeAlerta("Defina el dia por que el se sustituye", null, null);
                        return false;
                    }
                    if(this.DetalleIncidencia.Motivo==null)
                    {
                        comun.mensajeDeAlerta("Defina un Motivo para la incidencia", null, null);
                        return false;
                    }
                    var valor = this.VerificarDiasEnOtrasIncidencias(this.PersonaModal.Incidencias, this.DetalleIncidencia)
                    if(valor.Estatus== false)
                        {
                            this.ListadoIncidencias.push(this.DetalleIncidencia);
                        }
                        else
                        {
                            comun.mensajeDeAlerta("No se Puede Crear Incidencia, algun(os) dia(as) coincide con otra incidencia registrada No. " + valor.Incidencia, null, null);
                            return false;
                        }
                }

            };
            if(this.parametros_Incidencia.tipoIncidenciaId == 3) //Solicitud de Permiso
            {
                if(this.parametros_SubIncidencia.tipoSubCategoriaIncidenciaId == -1)
                {
                    comun.mensajeDeAlerta("Seleccione una categoria para la incidencia", null, null);
                    return false;
                };
                if(this.parametros_SubIncidencia.tipoSubCategoriaIncidenciaId ==4) // Permiso de Estudiante
                {
                    if(this.DetalleIncidencia.FechaInicio==null)
                    {
                        comun.mensajeDeAlerta("Defina inicio del período", null, null);
                        return false;
                    };
                    if(this.DetalleIncidencia.FechaTermino==null)
                    {
                        comun.mensajeDeAlerta("Defina fin del período", null, null);
                        return false;
                    };
                    if(this.DetalleIncidencia.FechaInicio>this.DetalleIncidencia.FechaTermino)
                    {
                        comun.mensajeDeAlerta("Fecha de inicio del Período no puede ser mayor a la Fecha de Termino", null, null);
                        return false;
                    };
                    if(this.DetalleIncidencia.HoraInicio==null)
                    {
                        comun.mensajeDeAlerta("Defina inicio del Horario", null, null);
                        return false;
                    };
                    if(this.DetalleIncidencia.HoraFinal==null)
                    {
                        comun.mensajeDeAlerta("Defina final del Horario", null, null);
                        return false;
                    };
                    if(this.DetalleIncidencia.HoraInicio>this.DetalleIncidencia.HoraFinal)
                    {
                        comun.mensajeDeAlerta("El inicio del Horario no puede ser mayor al fin del Horario", null, null);
                        return false;
                    };
                    var valor = this.VerificarDiasEnOtrasIncidencias(this.PersonaModal.Incidencias, this.DetalleIncidencia);
                        if(valor.Estatus== false)
                        {
                            this.ListadoIncidencias.push(this.DetalleIncidencia);
                        }
                        else
                        {
                            comun.mensajeDeAlerta("No se Puede Crear Incidencia, algun(os) dia(as) coincide con otra incidencia registrada No " + valor.Incidencia, null, null);
                            return false;
                        }
                }
                if(this.parametros_SubIncidencia.tipoSubCategoriaIncidenciaId ==5) // Hora Lactancia
                {
                     if(this.DetalleIncidencia.FechaInicio==null)
                    {
                        comun.mensajeDeAlerta("Defina inicio del período", null, null);
                        return false;
                    };
                    if(this.DetalleIncidencia.FechaTermino==null)
                    {
                        comun.mensajeDeAlerta("Defina fin del período", null, null);
                        return false;
                    };
                    if(this.DetalleIncidencia.FechaInicio>this.DetalleIncidencia.FechaTermino)
                    {
                        comun.mensajeDeAlerta("Fecha de inicio del Período no puede ser mayor a la Fecha de Termino", null, null);
                        return false;
                    };
                    if(this.DetalleIncidencia.HoraInicio==null)
                    {
                        comun.mensajeDeAlerta("Defina inicio del Horario", null, null);
                        return false;
                    };
                    if(this.DetalleIncidencia.HoraFinal==null)
                    {
                        comun.mensajeDeAlerta("Defina final del Horario", null, null);
                        return false;
                    };
                    if(this.DetalleIncidencia.HoraInicio>this.DetalleIncidencia.HoraFinal)
                    {
                        comun.mensajeDeAlerta("El inicio del Horario no puede ser mayor al fin del Horario", null, null);
                        return false;
                    };
                    var valor = this.VerificarDiasEnOtrasIncidencias(this.PersonaModal.Incidencias, this.DetalleIncidencia);
                        if(valor.Estatus== false)
                        {
                            this.ListadoIncidencias.push(this.DetalleIncidencia);
                        }
                        else
                        {
                            comun.mensajeDeAlerta("No se Puede Crear Incidencia, algun(os) dia(as) coincide con otra incidencia registrada No " + valor.Incidencia, null, null);
                            return false;
                        }
                };
                if(this.parametros_SubIncidencia.tipoSubCategoriaIncidenciaId ==6) //Otro
                {
                    if (this.DetalleIncidencia.Motivo== null && this.DetalleIncidencia.Motivo =="" )
                    {
                        comun.mensajeDeAlerta("Describa un Motivo para Esta Solicitud de Incidencia", null, null);
                        return false;
                    };
                    this.ListadoIncidencias.push (this.DetalleIncidencia);
                }
            };
            if(this.parametros_Incidencia.tipoIncidenciaId == 4) //Licencia con goce de Sueldo
            {
                
                if(this.parametros_SubIncidencia.tipoSubCategoriaIncidenciaId == -1)
                {
                    comun.mensajeDeAlerta("Seleccione una categoria para la incidencia", null, null);
                    return false;
                };
                if(this.parametros_SubIncidencia.tipoSubCategoriaIncidenciaId == 7 || this.parametros_SubIncidencia.tipoSubCategoriaIncidenciaId == 8 || this.parametros_SubIncidencia.tipoSubCategoriaIncidenciaId == 10 )
                {
                    if(this.DetalleIncidencia.Nombre == null)
                    {
                        comun.mensajeDeAlerta("Complete el Nombre del Pariente para incidencia", null, null);
                        return false;
                    };
                    if(this.parametros_tipoParentesco.tipoParentescoId==-1 )
                    {
                        comun.mensajeDeAlerta("Seleccione un Tipo de Parentesco", null, null);
                        return false;
                    };

                    if(this.DetalleIncidencia.FechaInicio== null)
                    {
                        comun.mensajeDeAlerta("Defina Inicio de período de Licencia", null, null);
                        return false;
                    };
                    if(this.DetalleIncidencia.FechaTermino == null)
                    {
                        comun.mensajeDeAlerta("Defina Fin de período de Licencia", null, null);
                        return false;
                    };
                    if(this.DetalleIncidencia.FechaTermino < this.DetalleIncidencia.FechaInicio)
                    {
                        comun.mensajeDeAlerta("Incio de Período no puede ser mayor a Final de Período", null, null);
                        return false;
                    };
                    var valor = this.VerificarDiasEnOtrasIncidencias(this.PersonaModal.Incidencias, this.DetalleIncidencia);
                    if(valor.Estatus==false)
                    {
                        this.ListadoIncidencias.push (this.DetalleIncidencia);
                    }
                    else
                    {
                        comun.mensajeDeAlerta("No se Puede Crear Incidencia por traslape de período con uno ya registrado No. " + valor.Incidencia, null, null);
                        return false;
                    };
                };
                if(this.parametros_SubIncidencia.tipoSubCategoriaIncidenciaId == 9 || this.parametros_SubIncidencia.tipoSubCategoriaIncidenciaId == 11)
                {
                    if(this.DetalleIncidencia.FechaInicio== null)
                    {
                        comun.mensajeDeAlerta("Defina Inicio de período de Licencia", null, null);
                        return false;
                    };
                    if(this.DetalleIncidencia.FechaTermino == null)
                    {
                        comun.mensajeDeAlerta("Defina Fin de período de Licencia", null, null);
                        return false;
                    };
                    if(this.DetalleIncidencia.FechaTermino < this.DetalleIncidencia.FechaInicio)
                    {
                        comun.mensajeDeAlerta("Incio de Período no puede ser mayor a Final de Período", null, null);
                        return false;
                    }
                   
                }
                var valor = this.VerificarDiasEnOtrasIncidencias(this.PersonaModal.Incidencias, this.DetalleIncidencia);
                if(valor.Estatus==false)
                    {
                        this.ListadoIncidencias.push (this.DetalleIncidencia);
                    }
                else
                    {
                        comun.mensajeDeAlerta("No se Puede Crear Incidencia por traslape de período con uno ya registrado No. " + valor.Incidencia, null, null);
                        return false;
                    };
            }
            if(this.parametros_Incidencia.tipoIncidenciaId == 5) //Licencia Maternidad /Paternidad
            {
                if(this.parametros_SubIncidencia.tipoSubCategoriaIncidenciaId == -1)
                {
                    comun.mensajeDeAlerta("Seleccione una categoria para la incidencia", null, null);
                    return false;
                };
                if(this.DetalleIncidencia.FechaInicio == null)
                {
                    comun.mensajeDeAlerta("Defina fecha para inicio de Período", null, null);
                    return false;
                };
                if(this.DetalleIncidencia.FechaTermino == null)
                {
                    comun.mensajeDeAlerta("Defina fecha para final de Período", null, null);
                    return false;
                };
                if(this.DetalleIncidencia.FechaTermino < this.DetalleIncidencia.FechaInicio)
                {
                    comun.mensajeDeAlerta("Fecha de Inicio no puede ser mayor a Fecha de Termino para Período", null, null);
                    return false;
                };
                var valor = this.VerificarDiasEnOtrasIncidencias(this.PersonaModal.Incidencias, this.DetalleIncidencia);
                if(valor.Estatus== false)
                        {
                            this.ListadoIncidencias.push(this.DetalleIncidencia);
                        }
                        else
                        {
                            comun.mensajeDeAlerta("No se Puede Crear Incidencia, algun(os) dia(as) coincide con otra incidencia registrada No. " + valor.Incidencia, null, null);
                            return false;
                        }
            }
            if(this.parametros_Incidencia.tipoIncidenciaId == 6) //Extension Licencia Maternidad
            {
                this.DetalleIncidencia.Motivo = "";
                if(this.DetalleIncidencia.FechaInicio == null)
                {
                    comun.mensajeDeAlerta("Defina fecha para inicio de Período", null, null);
                    return false;
                };
                if(this.DetalleIncidencia.FechaTermino == null)
                {
                    comun.mensajeDeAlerta("Defina fecha para final de Período", null, null);
                    return false;
                };
                if(this.DetalleIncidencia.FechaTermino < this.DetalleIncidencia.FechaInicio)
                {
                    comun.mensajeDeAlerta("Fecha de Inicio no puede ser mayor a Fecha de Termino para Período", null, null);
                    return false;
                };
                if(this.checkMotivo.mot1 == false && this.checkMotivo.mot2 == false && this.checkMotivo.mot3 == false && this.checkMotivo.mot4 == false)
                {
                    comun.mensajeDeAlerta("Seleccione al menos un motivo", null, null);
                    return false;
                }
                else
                {
                    if(this.checkMotivo.mot1!=false)
                    {
                        this.DetalleIncidencia.Motivo = this.DetalleIncidencia.Motivo + document.getElementById("label1_id").innerHTML + "\n" ;
                    };
                    if(this.checkMotivo.mot2!=false)
                    {
                        this.DetalleIncidencia.Motivo =  this.DetalleIncidencia.Motivo + document.getElementById("label2_id").innerHTML + "\n";
                    };
                    if(this.checkMotivo.mot3!=false)
                    {
                        this.DetalleIncidencia.Motivo =  this.DetalleIncidencia.Motivo + document.getElementById("label3_id").innerHTML + "\n";
                    };
                    if(this.checkMotivo.mot4!=false)
                    {
                        this.DetalleIncidencia.Motivo = this.DetalleIncidencia.Motivo + document.getElementById("label4_id").innerHTML;
                    };
                    
                };
                var valor = this.VerificarDiasEnOtrasIncidencias(this.PersonaModal.Incidencias, this.DetalleIncidencia);
                if(valor.Estatus== false)
                        {
                            this.ListadoIncidencias.push(this.DetalleIncidencia);
                        }
                        else
                        {
                            comun.mensajeDeAlerta("No se Puede Crear Incidencia, algun(os) dia(as) coincide con otra incidencia registrada No. " + valor.Incidencia, null, null);
                            return false;
                        }
            };
            if(this.parametros_Incidencia.tipoIncidenciaId == 7) // Extension Licencia Paternidad
            {
                this.DetalleIncidencia.Motivo = "";
                if(this.DetalleIncidencia.FechaInicio == null)
                {
                    comun.mensajeDeAlerta("Defina fecha para inicio de Período", null, null);
                    return false;
                };
                if(this.DetalleIncidencia.FechaTermino == null)
                {
                    comun.mensajeDeAlerta("Defina fecha para final de Período", null, null);
                    return false;
                };
                if(this.DetalleIncidencia.FechaTermino < this.DetalleIncidencia.FechaInicio)
                {
                    comun.mensajeDeAlerta("Fecha de Inicio no puede ser mayor a Fecha de Termino para Período", null, null);
                    return false;
                };
                if(this.checkMotivo.mot == false && this.checkMotivo.mot2 == false && this.checkMotivo.mot3 == false && this.checkMotivo.mot4 == false)
                {
                    comun.mensajeDeAlerta("Seleccione al menos un motivo", null, null);
                    return false;
                }
                else
                {
                    if(this.checkMotivo.mot1!=false)
                    {
                        this.DetalleIncidencia.Motivo = this.DetalleIncidencia.Motivo + document.getElementById("label1_id").innerHTML + "\n" ;
                    };
                    if(this.checkMotivo.mot2!=false)
                    {
                        this.DetalleIncidencia.Motivo =  this.DetalleIncidencia.Motivo + document.getElementById("label2_id").innerHTML + "\n";
                    };
                    if(this.checkMotivo.mot3!=false)
                    {
                        this.DetalleIncidencia.Motivo =  this.DetalleIncidencia.Motivo + document.getElementById("label3_id").innerHTML + "\n";
                    };
                    if(this.checkMotivo.mot4!=false)
                    {
                        this.DetalleIncidencia.Motivo = this.DetalleIncidencia.Motivo + document.getElementById("label4_id").innerHTML;
                    };
                    
                };
                var valor = this.VerificarDiasEnOtrasIncidencias(this.PersonaModal.Incidencias, this.DetalleIncidencia)
                if(valor.Estatus== false)
                        {
                            this.ListadoIncidencias.push(this.DetalleIncidencia);
                        }
                        else
                        {
                            comun.mensajeDeAlerta("No se Puede Crear Incidencia, algun(os) dia(as) coincide con otra incidencia registrada No. " + valor.Incidencia, null, null);
                            return false;
                        }
            };
            if(this.parametros_Incidencia.tipoIncidenciaId == 8) //Ausencia justificada Injustificada
            {
                if(this.parametros_SubIncidencia.tipoSubCategoriaIncidenciaId ==-1)
                {
                    comun.mensajeDeAlerta("Seleccione una categoria para la incidencia", null, null);
                    return false;
                };
                if(this.DetalleIncidencia.FechaInicio==null)
                {
                    comun.mensajeDeAlerta("Seleccione una fecha para la incidencia", null, null);
                    return false;
                };
                if(this.DetalleIncidencia.Motivo==null)
                {
                    comun.mensajeDeAlerta("Escriba un motivo para la incidencia", null, null);
                    return false;
                };
                if(this.VerificaEnIncidenciasExiste(this.PersonaModal.Incidencias, this.DetalleIncidencia.FechaInicio, this.parametros_Incidencia.tipoIncidenciaId, this.parametros_SubIncidencia.tipoSubCategoriaIncidenciaId)==false)
                { 
                    this.ListadoIncidencias.push (this.DetalleIncidencia);
                }
                else
                {
                    comun.mensajeDeAlerta("No se Puede Crear Incidencia, ya existe una incidencia regsitrada con este día", null, null);
                    return false;
                };
            };
            if(this.parametros_Incidencia.tipoIncidenciaId == 9) //Justificacion Entrada salida
            {
                if(this.parametros_SubIncidencia.tipoSubCategoriaIncidenciaId ==-1)
                {
                    comun.mensajeDeAlerta("Seleccione una categoria para la incidencia", null, null);
                    return false;
                };
                if(this.DetalleIncidencia.FechaInicio==null)
                {
                    comun.mensajeDeAlerta("Seleccione una fecha para la incidencia", null, null);
                    return false;
                };
                if(this.DetalleIncidencia.Motivo==null)
                {
                    comun.mensajeDeAlerta("Escriba un motivo para la incidencia", null, null);
                    return false;
                };
                if(this.VerificaEnIncidenciasExiste(this.PersonaModal.Incidencias, this.DetalleIncidencia.FechaInicio, this.parametros_Incidencia.tipoIncidenciaId, this.parametros_SubIncidencia.tipoSubCategoriaIncidenciaId)==false)
                { 
                    this.ListadoIncidencias.push (this.DetalleIncidencia);
                }
                else
                {
                    comun.mensajeDeAlerta("No se Puede Crear Incidencia, ya existe una incidencia regsitrada con este día", null, null);
                    return false;
                };
            };
            if(this.parametros_Incidencia.tipoIncidenciaId == 10) //Licencia sin Gonce de Sueldo
            {
                if(this.Estatus.Base==false){
                    comun.mensajeDeAlerta("No es posible Generar esta Incidencia", null, null);
                    return false;
                }
                if(this.DetalleIncidencia.FechaInicio == null)
                {
                    comun.mensajeDeAlerta("Defina fecha para inicio de Período", null, null);
                    return false;
                };
                if(this.DetalleIncidencia.FechaTermino == null)
                {
                    comun.mensajeDeAlerta("Defina fecha para final de Período", null, null);
                    return false;
                };
                if(this.DetalleIncidencia.FechaTermino < this.DetalleIncidencia.FechaInicio)
                {
                    comun.mensajeDeAlerta("Fecha de Inicio no puede ser mayor a Fecha de Termino para Período", null, null);
                    return false;
                };
                if(this.DetalleIncidencia.Motivo==null)
                {
                    comun.mensajeDeAlerta("Escriba un Motivo para la Incidencia", null, null);
                    return false;
                };
                var valor = this.VerificarDiasEnOtrasIncidencias(this.PersonaModal.Incidencias, this.DetalleIncidencia)
                if(valor.Estatus== false)
                        {
                            this.ListadoIncidencias.push(this.DetalleIncidencia);
                        }
                        else
                        {
                            comun.mensajeDeAlerta("No se Puede Crear Incidencia, algun(os) dia(as) coincide con otra incidencia registrada No. " + valor.Incidencia, null, null);
                            return false;
                        };
            };
            return true;
        },
        CrearIncidencia(){
            if(this.ValidaCamposPorTipoIncidencia()==true)
            {
                var ServidorPublico = this.PersonaModal;
                var Detalles = this.ListadoIncidencias;
                var nomina= parseInt(this.PersonaModal.NumeroNomina);
                var peticion = {
                    "Incidencia": {
                        "PersonaIncidencia" : {"PersonaId": ServidorPublico.PersonaId},
                        "EstatusIncidencia": {"TipoEstatusIncidenciaId": 1},
                        "TipoIncidencia": { "TipoIncidenciaId": this.parametros_Incidencia.tipoIncidenciaId},
                        "TipoSubIncidencia": {"TipoSubIncidenciaId": this.parametros_SubIncidencia.tipoSubCategoriaIncidenciaId!= -1? this.parametros_SubIncidencia.tipoSubCategoriaIncidenciaId : 0}
                        },
                    Detalles,
                    };
                comun.SeEstaCargandoInformacion(true);
                axios.post(api.conexion + api.SIAP.funcion.NuevaIncidencia, peticion,
                comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
                .then(respuesta => {
                    if (respuesta.data.SiHayError){
                        console.log(respuesta);
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                        this.LimpiaCampos();
                            this.ListadoIncidencias =  [];
                            comun.SeEstaCargandoInformacion(false);
                            this.ModalClose(false, true, nomina);
                        comun.SeEstaCargandoInformacion(false);
                    }
                    else
                    {
                        
                            comun.mensajeDeAlerta("Se ha Registrado la Incidencia", null, null);
                            this.LimpiaCampos();
                            this.ListadoIncidencias =  [];
                            comun.SeEstaCargandoInformacion(false);
                            this.ModalClose(false, true, nomina);
                    }
                    comun.SeEstaCargandoInformacion(false);
                    
                })
                .catch(e=> {
                    console.log("No Hay Respuesta del Servidor", e);
                    comun.SeEstaCargandoInformacion(false);
                    comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
                });
                this.ListadoIncidencias =  null;
            }
        },
        CerrarModal(){
            
            this.ModalClose(false, false, undefined);
        },
        AgregarDia(tipo, subTipo){
            let TurnoMixto = this.PersonaModal.EstructuraOrganica.TipoTurno.TipoTurnoId!=4 ? false : true;
            var conteo = this.ListadoDias.length;
            if (conteo<=this.ContDias)
            {
                if(this.DetalleIncidencia.Dia != null)
                {
                    var valor = this.VerificarDiasEnOtrasIncidencias(this.PersonaModal.Incidencias, this.DetalleIncidencia);
                    if( valor.Estatus == false)
                    {

                        // if(this.ListadoInhabiles.some(a=> a.C023DiaInhabil==this.DetalleIncidencia.Dia + 'T00:00:00')==true)//(fecha.getDay() == 5 || fecha.getDay() == 6)
                        // {
                        //     comun.mensajeDeAlerta("Seleccione un dia que no corresponda a día Inhabil", null, null);
                        // }
                        // else{
                            if(this.ListadoDias.some(a=> a.Dia==this.DetalleIncidencia.Dia)==false)
                            {
                                this.ListadoDias.push ({'No': 'Dia ' + (conteo+1) + ' de '+ this.ContDias,'Dia': this.DetalleIncidencia.Dia});
                                this.DiasTramite = this.DiasTramite - 1
                            }
                            else{
                                comun.mensajeDeAlerta("Ya existe este dia en el Listado", null, null);
                            }
                        //}
                    }
                    else
                    {
                       comun.mensajeDeAlerta("El Día a solicitar ya existe en una Incidencia Registrada No. "+ valor.Incidencia, null, null); 
                    }
                }
                else
                {
                    comun.mensajeDeAlerta("Seleccione un dia para Incidencia de Dia Económico", null, null);
                }
            }
            this.LimpiaCampos();
            this.ListadoDias.sort((a,b)=> (a.Dia>b.Dia ? 1 : -1));
            if(this.ListadoDias.length>1)
            {
                var i;
                    for (i = 0; i < this.ListadoDias.length; i++) {
                    this.ListadoDias[i].No = 'Dia ' + (i +1 ) + ' de ' + this.ContDias;
                } 
            };
        },
        EliminarDia(dato){
            
            this.DiasTramite = this.DiasTramite + 1;
            this.ListadoDias.splice(this.ListadoDias.indexOf(dato),1);
            var i;
                    for (i = 0; i < this.ListadoDias.length; i++) {
                    this.ListadoDias[i].No = 'Dia ' + (i +1 ) + ' de ' + this.ContDias;
                } 
        },
        ObtieneContadorDiasSolicitados(listado)
        {
            var Anio = parseInt(moment().format('YYYY'));
            var Solicitados = [];
            var TotalSolicitados = 0;
            Solicitados = listado.filter(e=>e.TipoIncidencia.TipoIncidenciaId==2 && e.TipoSubIncidencia.TipoSubIncidenciaId==1 && e.EstatusIncidencia.TipoEstatusIncidenciaId !=4);
            $.each(Solicitados, function(index, lista)
            {
                var DiasdelAnio = lista.Detalles.filter(e=>e.Dia >= Anio + '-01-01 00:00:01' && e.Dia <= Anio + '-12-31 23:59:59')
                TotalSolicitados = TotalSolicitados + DiasdelAnio.length;
            })
            return TotalSolicitados;
        },
        VerificaEnIncidenciasExiste(listado, IncidenciaDia, tipo, subTipo){
            var Contador= 0;
            var VerSolicitados = listado.filter(e=>e.TipoIncidencia.TipoIncidenciaId==tipo && e.TipoSubIncidencia.TipoSubIncidenciaId==subTipo && e.EstatusIncidencia.TipoEstatusIncidenciaId !=4);
            $.each(VerSolicitados, function(index, lista)
            {
                $.each(lista.Detalles, function(index, diasListados)
                {
                    if(moment(diasListados.Dia).format('YYYY-MM-DD')==IncidenciaDia)
                    {
                        Contador+=1
                    }
                });
            })
            if(Contador>0)
            {
                return true;
            }
            else
            {
                return false;
            }
        }, 
        ObtenerDiasHabiles(inicio, fin){
            var contador=0;
            var FechaInicial= moment(inicio);
            var FechaFinal = moment(fin);
            var Diff = FechaFinal.diff(FechaInicial, 'days') + 1;
            var i;
            for (i = 0; i < Diff; i++) {
                var diaAVerificar;
                if(i==0)
                    {
                        diaAVerificar=FechaInicial.add({'days': i}).format('YYYY-MM-DD') + 'T00:00:00';
                    }
                else
                    {
                        diaAVerificar=FechaInicial.add({'days': 1}).format('YYYY-MM-DD') + 'T00:00:00';
                    };
                if(this.ListadoInhabiles.some(a=> a.C023DiaInhabil==diaAVerificar)==false)
                {
                    contador=contador +1; 
                }
            } 
            return contador;
        },
        ObtenerDiasVacacionesEnIncidencias(listado, periodo, anio){
            var Solicitados = [];
            var TotalSolicitados = 0;
            Solicitados = listado.filter(e=>e.TipoSubIncidencia.TipoSubIncidenciaId==2 || e.TipoSubIncidencia.TipoSubIncidenciaId==3 && e.EstatusIncidencia.TipoEstatusIncidenciaId !=4);
            $.each(Solicitados, function(index, lista)
            {
                $.each(lista.Detalles, function(index, detalles)
                {
                    if(detalles.Anio == anio && detalles.Periodo==periodo)
                    {
                        TotalSolicitados = TotalSolicitados + detalles.DiasVacaciones;
                        
                    }
                })
            })
            return TotalSolicitados;
        },
        DetectarEmpalmeVacaciones(listado, periodo, anio){
            var Incidencias =[];
            var ListaDiasTramitados = [];
            
            Incidencias = listado.filter(e=>e.TipoIncidencia.TipoIncidenciaId==2 && e.TipoSubIncidencia.TipoSubIncidenciaId==2 && e.EstatusIncidencia.TipoEstatusIncidenciaId !=4);
            $.each(Incidencias, function (index, diasTramitados)
            {
                $.each(diasTramitados.Detalles, function(id, detalles)
                {
                    if(detalles.Periodo == periodo && detalles.Anio==anio)
                    {
                        var conteo = detalles.DiasVacaciones;
                        var i;
                        for (i = 0; i < conteo; i++)
                        {   
                            var dia =moment(detalles.FechaInicio).add({'days': i}).format('YYYY-MM-DD');
                            ListaDiasTramitados.push({'DiaVacacional': dia});
                        }
                    }
                });
            });
            var FechaInicial= moment(this.DetalleIncidencia.FechaInicio);
            var FechaFinal = moment(this.DetalleIncidencia.FechaTermino);
            var Diff = FechaFinal.diff(FechaInicial, 'days') + 1;
            var x;
            for (x = 0; x < Diff; x++)
            {   
                var dia =moment(this.DetalleIncidencia.FechaInicio).add({'days': x}).format('YYYY-MM-DD');
                
                if(ListaDiasTramitados.some(a=> a.DiaVacacional==dia)==true)
                {
                    return true;
                }
            };
            return false;
        },
        VerificarPermiso(listado, tipo, subTipo){
            var ListaDiasTramitados = [];
            var Incidencias = listado.filter(e=>e.TipoIncidencia.TipoIncidenciaId==tipo  && e.EstatusIncidencia.TipoEstatusIncidenciaId !=4);
            if(subTipo!=-1)
            {
                Incidencias = Incidencias.filter(e=>e.TipoSubIncidencia.TipoSubIncidenciaId==subTipo);
            }
            $.each(Incidencias, function (index, diasPermiso)
                {
                    $.each(diasPermiso.Detalles, function(id, detalles)
                        {
                        var FechaInicialPermiso= moment(detalles.FechaInicio);
                        var FechaFinalPermiso = moment(detalles.FechaTermino);
                        var conteo = FechaFinalPermiso.diff(FechaInicialPermiso, 'days') + 1;
                        var i;
                        for (i = 0; i < conteo; i++)
                        {   
                            var dia =moment(detalles.FechaInicio).add({'days': i}).format('YYYY-MM-DD');
                            ListaDiasTramitados.push({'DiaPermiso': dia});
                        }
                        
                        });
                });
            var FechaInicial= moment(this.DetalleIncidencia.FechaInicio);
            var FechaFinal = moment(this.DetalleIncidencia.FechaTermino);
            var Diff = FechaFinal.diff(FechaInicial, 'days') + 1;
            var x;
            for (x = 0; x < Diff; x++)
                {   
                    var dia =moment(this.DetalleIncidencia.FechaInicio).add({'days': x}).format('YYYY-MM-DD');
                    if(ListaDiasTramitados.some(a=> a.DiaPermiso==dia)==true)
                    {
                        return true;
                    }
                };
            return false;
        },
        Maternidad(dias){
            var fecha1= moment(this.DetalleIncidencia.FechaInicio);
            var fecha2 = fecha1.add(84, 'days').format('YYYY-MM-DD');
            this.DetalleIncidencia.FechaTermino = fecha2;
        },
        AgregarFaltas(tipo, subTipo){
            var conteo = this.ListadoDias.length;
            
                if(this.DetalleIncidencia.Dia != null)
                {
                    if(this.VerificaEnIncidenciasExiste(this.PersonaModal.Incidencias, this.DetalleIncidencia.Dia, tipo, subTipo) == false)
                    {
                        
                        if(this.ListadoInhabiles.some(a=> a.C023DiaInhabil==this.DetalleIncidencia.Dia + 'T00:00:00')==true)//(fecha.getDay() == 5 || fecha.getDay() == 6)
                        {
                            comun.mensajeDeAlerta("Seleccione un dia que no corresponda a día Inhabil", null, null);
                        }
                        else{
                            if(this.ListadoDias.some(a=> a.Dia==this.DetalleIncidencia.Dia)==false)
                            {
                                this.ListadoDias.push ({'No': 'Dia ' + (conteo+1) + ' de '+ (conteo+1), 'Dia': this.DetalleIncidencia.Dia});
                            }
                            else{
                                comun.mensajeDeAlerta("Ya existe este dia en el Listado", null, null);
                            }
                        }
                    }
                    else
                    {
                       comun.mensajeDeAlerta("El Día a solicitar ya existe en una Incidencia Registrada", null, null); 
                    }
                }
                else
                {
                    comun.mensajeDeAlerta("Seleccione un dia para Incidencia de Dia Económico", null, null);
                }
            this.LimpiaCampos();
            this.ListadoDias.sort((a,b)=> (a.Dia>b.Dia ? 1 : -1));
            if(this.ListadoDias.length>1)
            {
                var i;
                    for (i = 0; i < this.ListadoDias.length; i++) {
                    this.ListadoDias[i].No = 'Dia ' + (i +1 ) + ' de ' + (conteo+1);
                } 
            };
        },
        ObtenerDiasASolicitar(inicio, fin){
            var contador=0;
            var FechaInicial= moment(inicio);
            var FechaFinal = moment(fin);
            var Diff = FechaFinal.diff(FechaInicial, 'days') + 1;
            var i;
            for (i = 0; i < Diff; i++) {
                var diaAVerificar;
                if(i==0)
                    {
                        diaAVerificar=FechaInicial.add({'days': i}).format('YYYY-MM-DD') + 'T00:00:00';
                    }
                else
                    {
                        diaAVerificar=FechaInicial.add({'days': 1}).format('YYYY-MM-DD') + 'T00:00:00';
                    };
                if(this.ListadoInhabiles.some(a=> a.C023DiaInhabil==diaAVerificar)==false)
                {
                    contador=contador +1; 
                }
            };
            if(this.DiasVacacionesDisponibles==0)
            {
                comun.mensajeDeAlerta("No se cuenta con dias disponibles para este periodo Vacacional", null, null);
                this.DetalleIncidencia.FechaInicio = null;
                this.DetalleIncidencia.FechaTermino = null;
            }
            else
            {
                if(contador>this.DiasVacacionesDisponibles)
                {
                    comun.mensajeDeAlerta("Los días solicitados sobrepasa a los días disponibles", null, null);
                    this.DetalleIncidencia.FechaTermino = null;
                    this.DiasASolicitar =0;
                }
                else {
                    this.DiasASolicitar = contador;
                };
            };
        },
        VerificarDiasEnOtrasIncidencias(listado, datos)
        {
            var anioCorriente = moment().format('YYYY');
            var Incidencias =[];
            var ListadoDiasIncidencias = [];
            Incidencias = listado.filter(e=>e.TipoIncidencia.TipoIncidenciaId!=1 && e.TipoIncidencia.TipoIncidenciaId!=8 && e.TipoIncidencia.TipoIncidenciaId!=9 && e.EstatusIncidencia.TipoEstatusIncidenciaId!= 4);
            $.each(Incidencias, function (index, diasTramitados)
            {
                
                $.each(diasTramitados.Detalles, function(index, detalles){
                    if(detalles.Dia!=null)
                    {
                        if(moment(detalles.Dia).format('YYYY') == anioCorriente)
                        {
                            ListadoDiasIncidencias.push({"Dia": moment(detalles.Dia).format('YYYY-MM-DD'), "IncidenciaId": diasTramitados.IncidenciaId })
                        }
                    }
                    if(detalles.FechaInicio!=null && detalles.FechaTermino!=null)
                    {
                        var FechaInicial= moment(detalles.FechaInicio);
                        var FechaFinal = moment(detalles.FechaTermino);
                        var Diff = FechaFinal.diff(FechaInicial, 'days') + 1;
                        var i;
                        for (i = 0; i < Diff; i++)
                            {   
                                var dia =moment(detalles.FechaInicio).add({'days': i}).format('YYYY-MM-DD');
                                ListadoDiasIncidencias.push({'Dia': dia,  "IncidenciaId": diasTramitados.IncidenciaId});
                            }
                    }
                    if(detalles.DiaSustitucion!=null)
                    {
                        if(moment(detalles.DiaSustitucion).format('YYYY') == anioCorriente)
                        {
                            ListadoDiasIncidencias.push({"Dia": moment(detalles.DiaSustitucion).format('YYYY-MM-DD'),  "IncidenciaId": diasTramitados.IncidenciaId })
                        }
                    }
                });
                
            });
            
            if(datos.Dia!=null)
                {
                    var filtro = ListadoDiasIncidencias.filter(e=>e.Dia==moment(datos.Dia).format('YYYY-MM-DD'));
                    if(filtro.length>0)
                    {
                        var resp = { "Estatus": true, "Incidencia": filtro[0].IncidenciaId}
                        return resp;
                    }
                };
            
            if(datos.FechaInicio!=null && datos.FechaTermino!=null)
                {
                    var FechaInicial= moment(datos.FechaInicio);
                    var FechaFinal = moment(datos.FechaTermino);
                    var Diff = FechaFinal.diff(FechaInicial, 'days') + 1;
                    var i;
                    for (i = 0; i < Diff; i++)
                    {   
                        var dia =moment(datos.FechaInicio).add({'days': i}).format('YYYY-MM-DD');
                        var filtro =ListadoDiasIncidencias.filter(e=>e.Dia==dia);
                        if(filtro.length>0)
                        {
                            var resp = { "Estatus": true, "Incidencia": filtro[0].IncidenciaId}
                            return resp;
                        }
                    }
                }
            if(datos.DiaSustitucion!=null)
                {
                    var filtro = ListadoDiasIncidencias.filter(e=>e.Dia==moment(datos.DiaSustitucion).format('YYYY-MM-DD'))
                    if(filtro.length>0){
                    var resp = { "Estatus": true, "Incidencia": filtro[0].IncidenciaId}
                    return resp; } 
                }
            var resp2 = { "Estatus": false, "Incidencia": 0}
            return resp2;
        },
        VerficarExisteEnVacaciones(dia){
            var detalles = [];
            $.each(this.PersonaModal.Incidencias, function(indice, lista)
            {
                if(lista.Detalles.length>0 && lista.Detalles!=null)
                {
                    if(lista.TipoSubIncidencia.TipoSubIncidenciaId == 2 || lista.TipoSubIncidencia.TipoSubIncidenciaId == 3)
                    {
                        $.each(lista.Detalles, function(index, elemento)
                        {
                            if(elemento.DiaSustitucion!=null)
                            {
                                detalles.push(moment(elemento.DiaSustitucion).format('YYYY-MM-DD'))
                            }
                            if(elemento.FechaInicio!=null && elemento.FechaTermino)
                            {
                                var FechaInicial= moment(elemento.FechaInicio);
                                var FechaFinal = moment(elemento.FechaTermino);
                                var Diff = FechaFinal.diff(FechaInicial, 'days') + 1;
                                var i;
                                for (i = 0; i < Diff; i++) {
                                    if(i==0)
                                        {
                                            detalles.push(FechaInicial.add({'days': i}).format('YYYY-MM-DD') );
                                        }
                                        else{
                                            detalles.push(FechaInicial.add({'days': 1}).format('YYYY-MM-DD') );
                                        }
                                };
                            }
                        })
                    }
                }
            })
            var valida = detalles.filter(e=>e == dia);
            if(valida.length==0)
            {
                this.DetalleIncidencia.DiasVacaciones = 1;
            }
            else
            {
                this.DetalleIncidencia.DiasVacaciones = null;
            }
        }
    },
    mounted(){
        this.Mostrar();
        var diasSolicitados = this.ObtieneContadorDiasSolicitados(this.PersonaModal.Incidencias);
        
        this.DiasTramite = 3 - diasSolicitados;
        this.ContDias = 3 - diasSolicitados;
    }
}
</script>
<style scoped>
    .thead-custom {
        background-color: #004746;
        color: white;
    }
    .modal-content {
      background-color:  #7e7f74;
    }
    .modal-header {
        background-color:  #007573;
    }
    .custom-area {
        background-color: #7e7f74;
    }
    .label-black {
        color: black;
    }
    .btn-custom {
        background-color: #004746;
        color: white;
    }
</style>


// WEBPACK FOOTER //
// src/components/SIAP/Incidencias/NuevaIncidencia.vue